module.exports = __webpack_public_path__ + "c8ddc7d62da566753a39df979f0176af.mp4";